exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#nav .pure-menu-item.active {\n  background: #dedede;\n}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/menu.vue
 ** module id = 22
 ** module chunks = 0
 **/